import React from 'react'
interface UsersProps {
    color?: string;
    size?: number;
}

export default function Users({
    color = "#79808A",
    size = 24,
}: UsersProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size + 1} viewBox="0 0 24 25" fill="none">
            <path d="M21.5996 21.307C21.5996 19.4954 19.9296 17.9551 17.5996 17.3831M15.5996 21.307C15.5996 19.0086 12.9136 17.147 9.59961 17.147C6.28561 17.147 3.59961 19.0086 3.59961 21.307M15.5996 14.027C16.6605 14.027 17.6779 13.5887 18.428 12.8086C19.1782 12.0284 19.5996 10.9703 19.5996 9.86703C19.5996 8.76373 19.1782 7.70562 18.428 6.92547C17.6779 6.14532 16.6605 5.70703 15.5996 5.70703M9.59961 14.027C8.53874 14.027 7.52133 13.5887 6.77118 12.8086C6.02104 12.0284 5.59961 10.9703 5.59961 9.86703C5.59961 8.76373 6.02104 7.70562 6.77118 6.92547C7.52133 6.14532 8.53874 5.70703 9.59961 5.70703C10.6605 5.70703 11.6779 6.14532 12.428 6.92547C13.1782 7.70562 13.5996 8.76373 13.5996 9.86703C13.5996 10.9703 13.1782 12.0284 12.428 12.8086C11.6779 13.5887 10.6605 14.027 9.59961 14.027Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}